import { render } from "./CustomerTypeList.vue?vue&type=template&id=e64fd614&scoped=true"
import script from "./CustomerTypeList.vue?vue&type=script&lang=js"
export * from "./CustomerTypeList.vue?vue&type=script&lang=js"

import "./CustomerTypeList.vue?vue&type=style&index=0&id=e64fd614&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64fd614"]])

export default __exports__